import { atom } from 'recoil';
import { IMetricsDataState } from './types';
import type { IDsMetrics, IDsMetricsItem } from '..';

const allmetrics: IDsMetrics | [] = [];
const initialState: IMetricsDataState = {};
const activeMetrics: IDsMetricsItem = {
  label: '',
  key: '',
};

export const AllMetricsListState = atom<IDsMetrics[]>({
  key: 'all-metric-list',
  default: allmetrics,
});

export const MetricsChartState = atom<IMetricsDataState>({
  key: 'metric-list',
  default: initialState,
});

export const SocialActiveMetricsState = atom<IDsMetricsItem>({
  key: 'social-active-metric',
  default: activeMetrics,
});

export const AdsActiveMetricsState = atom<IDsMetricsItem>({
  key: 'ads-active-metric',
  default: activeMetrics,
});

export const EmailActiveMetricsState = atom<IDsMetricsItem>({
  key: 'email-active-metric',
  default: activeMetrics,
});

export const WebActiveMetricsState = atom<IDsMetricsItem>({
  key: 'web-active-metric',
  default: activeMetrics,
});
